import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-analogue-panel-v2-dialog',
  templateUrl: './analogue-panel-v2-dialog.component.html',
  styleUrls: ['./analogue-panel-v2-dialog.component.scss']
})
export class AnaloguePanelV2DialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: { productId: number; productTitle?: string },
    private readonly dialogRef: MatDialogRef<AnaloguePanelV2DialogComponent>
  ) {}

  close() {
    this.dialogRef.close();
  }
}
